var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-heading" },
    _vm._l(_vm.columns, function(column, headerIndex) {
      return _c(
        "div",
        {
          directives: [
            {
              name: "profile-guard",
              rawName: "v-profile-guard",
              value: column.action,
              expression: "column.action"
            }
          ],
          key: headerIndex,
          staticClass: "table-item"
        },
        [
          column.sortable
            ? [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.sort(column.value)
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          column.label ? _vm.$t(column.label) : column.value
                        )
                      )
                    ]),
                    column.sortable
                      ? _c("span", {
                          staticClass: "glicon-order",
                          class: {
                            asc:
                              _vm.currentSortValue === column.value &&
                              _vm.isSortAscending,
                            desc:
                              _vm.currentSortValue === column.value &&
                              !_vm.isSortAscending
                          }
                        })
                      : _vm._e()
                  ]
                )
              ]
            : [
                _c("span", [
                  _vm._v(
                    _vm._s(column.label ? _vm.$t(column.label) : column.value)
                  )
                ])
              ]
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }